
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { 
  Globe, 
  Eye, 
  Database, 
  Mail, 
  Phone, 
  Trophy,
  ArrowRight 
} from 'lucide-react';

const processSteps = [
  {
    number: 1,
    title: "Website traffic activeren",
    description: "We voorzien een slimme landingspagina of verrijken jouw bestaande site. We boosten gericht verkeer via Google Ads of andere kanalen.",
    icon: Globe,
    color: "bg-blue-500"
  },
  {
    number: 2,
    title: "Realtime bezoekerherkenning",
    description: "Dankzij slimme tracking (Leadinfo) zien we welke bedrijven je website bezoeken. Surfgedrag wordt geanalyseerd (volledig GDPR-compliant).",
    icon: Eye,
    color: "bg-purple-500"
  },
  {
    number: 3,
    title: "Data-verrijking & signalen",
    description: "Automatische verrijking van bedrijfs- en contactdata. Sales intelligence opgebouwd in de achtergrond.",
    icon: Database,
    color: "bg-green-500"
  },
  {
    number: 4,
    title: "Gepersonaliseerde outreach",
    description: "Slimme e-mailcampagnes en LinkedIn-interacties worden getriggerd. Volledig afgestemd op het gedrag en de interesses van je bezoekers.",
    icon: Mail,
    color: "bg-orange-500"
  },
  {
    number: 5,
    title: "Warme leads voor je call agents",
    description: "Call agents ontvangen enkel verrijkte, gekwalificeerde leads. Met alle info: surfgedrag, contactmomenten, interesses, bedrijfssignalen.",
    icon: Phone,
    color: "bg-red-500"
  },
  {
    number: 6,
    title: "Resultaat",
    description: "Meer afspraken. Minder werk. 100% gefocust op echte kansen.",
    icon: Trophy,
    color: "bg-yellow-500"
  }
];

const AILeadEngineProcess = () => {
  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Hoe werkt de AI Lead Engine?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Van anonieme websitebezoeker naar gekwalificeerde afspraak in 6 slimme stappen
            </p>
          </div>

          {/* Process Steps */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {processSteps.map((step, index) => (
              <div key={step.number} className="relative">
                <Card className="h-full hover:shadow-lg transition-all transform hover:scale-105 border-t-4 border-t-brand-blue">
                  <CardHeader className="pb-4">
                    <div className="flex items-center gap-4 mb-4">
                      <div className={`${step.color} w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg`}>
                        {step.number}
                      </div>
                      <div className="bg-gray-100 p-2 rounded-lg">
                        <step.icon className="h-6 w-6 text-gray-700" />
                      </div>
                    </div>
                    <CardTitle className="text-lg font-semibold text-gray-900">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>

                {/* Arrow for desktop */}
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <div className="bg-white rounded-full p-2 shadow-md">
                      <ArrowRight className="h-4 w-4 text-brand-blue" />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Results Highlight */}
          <div className="bg-gradient-to-r from-brand-blue to-brand-darkBlue rounded-2xl p-12 text-white text-center">
            <h3 className="text-2xl font-bold mb-8">Het eindresultaat?</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div>
                <div className="text-3xl font-bold text-brand-lightBlue mb-2">10x</div>
                <div className="text-sm opacity-90">Minder manuele opvolging</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-brand-lightBlue mb-2">5x</div>
                <div className="text-sm opacity-90">Meer output</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-brand-lightBlue mb-2">100%</div>
                <div className="text-sm opacity-90">Warme, gekwalificeerde leads</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AILeadEngineProcess;
